import axios from "@/api/axios";

function getPersonalAccounts(username) {
  return axios.get(`geo/v1.0/user-personal-accounts/${username}/`);
}

function getPersonalAccountInfo() {
  return axios.get("services/v1.0/personal_account_info/");
}

function getCategories() {
  return axios.get("appeals/v1.0/personal_account_appeals/settings/categories/");
}

function getLocalityList(params) {
  return axios.get("geo/v1.0/locality/", { params });
}

function getThoroughfareList(params) {
  return axios.get("geo/v1.0/thoroughfare/", { params });
}

function getPremisesList(params) {
  return axios.get("geo/v1.0/premise/", { params });
}

function submitFeedback(data) {
  return axios.post("services/v1.0/manageorganization/feedback/", data);
}

export default {
  submitFeedback,
  getPersonalAccountInfo,
  getPersonalAccounts,
  getCategories,
  getLocalityList,
  getThoroughfareList,
  getPremisesList
};
